import { useEffect, useState } from "react";
import { ReactComponent as DeleteTag } from "../../../../assets/elevva-pro-icons/delete-tag.svg";
import { ReactComponent as EditTag } from "../../../../assets/elevva-pro-icons/edit-tag.svg";
import moment from "moment";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { instance, Loadingspinner } from "../../../../utils/utils";
import "./roles.css";

const rol = {
  10: "Super Usuario",
  20: "Operario",
  30: "Profesional de la salud",
};

const ModalListRoles = ({
  onConfirm,
  rolesSelected,
  setRolesSelected,
  loader,
  userRoles,
  detailCompany, setShowUsersLogsModal
}) => {
  return (
    <>
      <div className="mb-4 d-flex flex-column gap-3">
        <span
          style={{ textAlign: "center", fontSize: "calc( 0.85rem + 0.5vw )" }}
        >
          Listado <strong>Usuarios con Rol </strong>
        </span>
        <span
          style={{ textAlign: "center", fontSize: "calc( 0.45rem + 0.5vw )" }}
        >
          Usuarios disponibles : {detailCompany?.role_user_limit || 0}
        </span>
      </div>

      {loader ? (
        <div>
          <Loadingspinner customStyle="grow" size="2.5rem" />
        </div>
      ) : (
        <>
          <div className="d-flex align-items-center justify-content-end mb-2">
            <button type="button" className="btn btn-link recent-activities-button" onClick={() => { setShowUsersLogsModal(true) }}>
              Historial de cambios
            </button>
          </div>
          <PerfectScrollbar
            className="px-2"
            style={{
              maxHeight: "calc(67vh - 15rem)",
              overflowY: "scroll",
            }}
          >
            <table style={{ width: "100%" }}>
              <thead
                className="size-table-users"
                style={{
                  width: "100%",
                  overflow: "scroll",
                  position: "sticky",
                  top: "0",
                  backgroundColor: "white",
                  zIndex: "10",
                }}
              >
                <tr>
                  <th
                    className="pb-3 pt-3"
                    style={{
                      fontWeight: "normal",
                      width: "25%",
                    }}
                  >
                    <div className="d-flex gap-2 align-items-center ">
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          name="rollAll"
                          onClick={(e) => {
                            let checkedAll = e.target.checked;
                            if (checkedAll) {
                              setRolesSelected(
                                userRoles.map((user) => user.id)
                              );
                            } else {
                              setRolesSelected([]);
                            }
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>{" "}
                      <span className="size-table-users">Nombre</span>{" "}
                    </div>
                  </th>
                  <th
                    className="pb-3 pt-3"
                    style={{
                      fontWeight: "normal",
                      width: "35%",
                      textAlign: "left",
                    }}
                  >
                    Correo Electrónico
                  </th>

                  <th
                    className="pb-3 pt-3"
                    style={{
                      fontWeight: "normal",
                      width: "20%",
                      textAlign: "left",
                    }}
                  >
                    Etiqueta
                  </th>

                  <th
                    className="pb-3 pt-3"
                    style={{ fontWeight: "normal", width: "10%" }}
                  ></th>
                  <th
                    className="pb-3 pt-3"
                    style={{
                      fontWeight: "normal",
                      width: "15%",
                      textAlign: "left",
                    }}
                  >
                    Creación
                  </th>
                </tr>
              </thead>
              <tbody className="w-100">
                {userRoles.length > 0 &&
                  userRoles.map((user) => (
                    <tr
                      key={user.user_id}
                      className="size-table-users"
                      style={{
                        borderBottom: "1px solid #A8C2D7",
                        color: "#394F65",
                      }}
                    >
                      <td
                        style={{ width: "25%", textAlign: "left" }}
                        className="flex gap-2 align-items-center  py-3"
                      >
                        <div className="d-flex gap-2 align-items-center ">
                          <label className="custom-checkbox">
                            <input
                              type="checkbox"
                              name="user"
                              checked={rolesSelected.includes(user.id)}
                              onClick={() =>
                                setRolesSelected((prev) => {
                                  if (prev.includes(user.id)) {
                                    return prev.filter(
                                      (item) => item !== user.id
                                    );
                                  }
                                  return [...prev, user.id];
                                })
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <div className="size-table-users">
                            {user.first_name} {user.last_name}
                          </div>
                        </div>
                      </td>
                      <td style={{ width: "35%", textAlign: "left" }}>
                        {user.email}
                      </td>

                      <td style={{ width: "20%", textAlign: "left" }}>
                        {user?.role ? rol[user.role] : "----"}
                      </td>
                      <td style={{ width: "10%", textAlign: "right" }}>
                        <div className="d-flex">
                          <span className="button-icon">
                            <EditTag
                              onClick={() => {
                                setRolesSelected([user.id]);
                                onConfirm("edit");
                              }}
                            />
                          </span>
                          <span className="button-icon">
                            <DeleteTag
                              onClick={() => {
                                setRolesSelected([user.id]);
                                onConfirm("delete");
                              }}
                            />
                          </span>
                        </div>
                      </td>
                      <td style={{ width: "15%", textAlign: "left" }}>
                        {user.created_at
                          ? moment(user.created_at)?.format("DD-MMM-YY")
                          : "---"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </PerfectScrollbar>
          <div className="d-flex mt-5 justify-content-center align-items-center gap-xl-3 gap-md-2">
            {rolesSelected.length > 0 && (
              <button
                style={{
                  fontSize: "calc(.4rem + .32vw)",
                  background: "#3177BE",
                }}
                className="d-flex add_location px-4 py-1"
                onClick={() => {
                  onConfirm("delete");
                }}
              >
                Eliminar Usuarios <strong className="ms-1">-</strong>
              </button>
            )}
            <button
              style={{
                fontSize: "calc(.4rem + .32vw)",
              }}
              className="d-flex add_location px-4 py-2"
              onClick={() => onConfirm("add")}
            >
              Agregar otro usuario
            </button>
          </div>
        </>
      )}
    </>
  );
};
export default ModalListRoles;
